<template lang="html">

  <section class="banner-contacto row-end">

    <div class="container row-end">

      <img src="/static/img/telefono-small-movil.webp" class="tlf-movil" alt="Decoración de teléfono">

      <div class="contenedor-info">

        <h3 class="-dark-orange">{{ $t('contactBanner.title') }}</h3>

        <p>{{ $t('contactBanner.text1') }}</p>
        <p class="-purple"><strong>{{ $t('contactBanner.text2') }}</strong></p>
        <article class="banner-llamame" :enviado="phoneok">

          <h4 class="-dark">{{ $t('contactBanner.form.label') }}</h4>

          <div class="contenedor-input">
            <input type="text" :placeholder="$t('contactBanner.form.placeholder')" data-aos-delay="200"
              v-model="data.telefono" v-validate="'required|length:9'" name="telefono">
            <button @click="validateBeforeSubmit" :loading="loading" class="btn
              -degree" data-aos-delay="300" title="LLámame">{{ $t('contactBanner.form.btn') }}</button>
            <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('telefono') }}</span>
          </div>

          <div class="contenedor-check">
            <input type="checkbox" name="politica_telefono" id="politica-banner-contacto" v-validate="'required'"
              v-model="data.politica">
            <label data-aos-delay="500" for="politica-banner-contacto">
              {{ $t('contactBanner.form.showPolicy') }}
              <router-link :to="$t('enlaces.politica_privacidad')">
                {{ $t('contactBanner.form.policy') }}
              </router-link>
            </label>
            <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first('politica_telefono')
              }}</span>
          </div>

          <div class="result-ok column-start" :phoneok="phoneok" :enviado="enviado">
            <div class="top row-start">
              <span class="tick">
                <img src="/static/img/tick.svg" alt="Enviado correctamente. Nos
                  pondremos en contacto contigo.">
              </span>
              <h2>{{ $t('contactBanner.callSchedule.title') }} <i>({{ horas[data.horario] }})</i></h2>
            </div>
            <div class="bottom row-start" v-if="!enviado">
              <h4 class="-dark-orange">
                {{ $t('contactBanner.callSchedule.text') }}
              </h4>
              <select name="horario" class="select-tarifa" aria-label="Selecciona tu horario" v-model="data.horario"
                @change="send">
                <option v-for="(hora, key) in horas" :value="key">{{ hora }}</option>
              </select>
            </div>
            <span v-if="!enviado" :active="phoneok" class="countdown">
              <figure></figure>
            </span>
          </div>

        </article>



        <h4 class="-orange">{{ $t('contactBanner.text3') }}
          <a href="tel:900848402" @click="trackPhoneClick">
            900 848 402
          </a>
        </h4>
      </div>

    </div>

    <span class="telefono" data-aos-delay="1000"></span>

  </section>

</template>

<script lang="js">
import Vue from 'vue';
import VeeValidate from 'vee-validate';

import { mapActions } from 'vuex';

Vue.use(VeeValidate);
export default {
  name: 'banner-contacto',
  data() {
    return {
      clicked: false,
      phoneok: false,
      loading: false,
      enviado: false,
      timeout: '',
      horas: ['de 9 a 19h', 'de 9 a 12h', 'de 12 a 15h', 'de 15 a 19h'],
      data: {
        telefono: '',
        horario: 0,
        url: '',
        politica: false
      }
    }
  },
  methods: {
    ...mapActions(['requestLlamada']),
    validateBeforeSubmit: function () {
      this.clicked = true;
      this.$validator.validateAll().then(canSend => {
        if (canSend) {
          this.phoneok = true;

          this.timeout = setTimeout(() => {
            this.send();
          }, 10000);
        }
      });
    },
    send() {

      this.data.url = this.$route.fullPath

      clearTimeout(this.timeout);

      this.requestLlamada(this.data).then(r => {

        this.$ga.event({
          eventCategory: 'Home',
          eventAction: 'clic',
          eventLabel: 'clic-llamame',
          eventValue: 0
        });

        this.enviado = r;

        setTimeout(e => {

          this.phoneok = false;

          this.data = {
            telefono: '',
            horario: 0,
            url: '',
            politica: false
          };

          this.$validator.reset();

          setTimeout(e => {
            this.enviado = false;
          }, 3000)

        }, 2000)

      });
    },
    trackPhoneClick() {
      this.gtag_report_conversion();
    },
    gtag_report_conversion(url) {
      const callback = function () {
        if (typeof url !== 'undefined') {
          window.location = url;
        }
      };
      if (typeof gtag !== 'undefined') {
        gtag('event', 'conversion', {
          'send_to': 'AW-692816998/WlrfCIOgwfYaEOaYrsoC',
          'value': 1.0,
          'currency': 'EUR',
          'event_callback': callback
        });
      }
      return false;
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/colors.scss';


.banner-contacto {
  background: linear-gradient(to bottom, #f9f7fc, #f9f7fc);
  width: 100%;
  text-align: left;
  position: relative;
  padding: 10vw 0;
  overflow: hidden;


  .telefono {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: inline-block;
    background: url("/static/img/fondo-telefono.webp") center/auto 100% no-repeat;
  }
}



.tlf-movil {
  display: none;
}

.container {
  position: relative;
  z-index: 3;
  overflow: hidden;
}

.contenedor-info {
  width: 50%;
}

.contenedor-input {
  margin-bottom: 0;
}

.contenedor-check .error {
  padding-left: 0;
  color: $dark-orange;
}

p {
  max-width: 420px;
}

.banner-llamame {
  margin-top: 20px;
  position: relative;
  overflow: hidden;
  max-width: 600px;

  .contenedor-input,
  .contenedor-check,
  h4 {
    transition: .8s;
    transition-delay: .3s;
  }

  &[enviado="true"] {

    .contenedor-input,
    .contenedor-check,
    h4{
      transition-delay: 0s;
      transform: translateX(100%);
    }

  }

}

.result-ok {
  position: absolute;
  left: -100%;
  top: 0%;
  width: 100%;
  height: 100%;
  transition: .8s;
  transition-timing-function: ease-in-out;
  z-index: 3;

  &[phoneok="true"] {
    transform: translateX(100%);
  }

  .tick {
    background: $degree;
    width: 40px;
    height: 40px;
    line-height: 40px;
    display: inline-block;
    text-align: center;
    border-radius: 50%;
  }

  h2 {
    margin-bottom: 0;
    font-weight: 800;
    margin-left: 30px;

    i {
      font-style: normal;
      font-size: 18px;
    }
  }

  .bottom {
    margin-top: 10px;

    h4 {
      transform: none;
      font-size: 18px;
      margin-right: 10px;
    }
  }


}

@media screen and (max-width: 1100px) {

  .banner-contacto {
    padding: 0;
  }

  .contenedor-info {
    width: 100%;
    padding: 50px;
    background: url("/static/img/telefono-small.webp") center right/auto 100% no-repeat;
  }

  .banner-contacto .telefono {
    background: #f9f9fb;
  }

}

@media screen and (max-width: 850px) {
  .contenedor-info {
    padding: 40px 0px;
  }
}

@media screen and (max-width: 800px) {
  .contenedor-info {
    background: transparent;
    padding-top: 0;
  }

  .container {
    justify-content: center;
    -webkit-justify-content: center;
  }

  .tlf-movil {
    display: inline-block;
    max-width: 100%;
    margin-top: 20px;
  }

  p {
    /*max-width: 100%;*/
  }
}

@media screen and (max-width: 650px) {
  .contenedor-input input {
    min-width: 0;
    margin-right: 10px;
    width: calc(100% - 160px);
    border: 1px solid $dark;
    margin-bottom: 10px;
  }

  .contenedor-input a {
    min-width: 0;
    padding: 0;
    width: 140px;
  }


  h4 {
    font-size: 18px;
  }

  .result-ok {
    .tick {
      display: none;
    }

    h2 {
      margin-left: 0;
    }
  }


}

@media screen and (max-width: 496px) {
  .result-ok h2 {
    font-size: 20px;
    line-height: 20px;
    margin-bottom: 5px;

    i {
      width: 100%;
      display: inline-block;
      font-size: 14px;
    }
  }

  .banner-llamame {
    padding-bottom: 20px;
  }

  .result-ok .bottom {
    margin-top: 0;
  }

  .result-ok .bottom h4 {
    font-size: 16px;
  }


}

@media screen and (max-width: 376px) {
  .contenedor-input input {
    width: calc(100% - 134px);
  }

  .contenedor-input a {
    width: 120px;
    font-size: 14px;
    letter-spacing: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/banner-contacto.vue